import React, {Component} from 'react';
import axios from "axios";

import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from '@ckeditor/ckeditor5-build-decoupled-document';

import AuthService from "../../AuthService";
import loader from "../../img/loader.gif";
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

Editor.defaultConfig = {
    toolbar: [ 'fontfamily', 'fontsize', 'fontbackgroundcolor', 'fontcolor', '|', 'bold', 'italic', 'underline', '|','bulletedList', 'numberedList', '|' , 'indent', 'outdent', '|' , 'link', 'blockQuote', '|', 'undo', 'redo' ],
    language: 'fr'
};

class ProcessDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            result: null,
            data: {},
            formData: {
                croisiere: {
                    id: this.props.croisiereId
                },
                croisiereStatutId: "",
                mailTo: "",
                mailCopy: "",
                mailObject: "",
                mailBody: "",
                mailFiles: "",
            }
        }

        this.change = this.change.bind(this);
        this.filesChange = this.onFilesChange.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        await axios.post(AuthService.getUrl('/getCrosisereMail'), {
            croisiere: {
                id: this.props.croisiereId
            }
        }, AuthService.getAuthHeader()).then(res => {
            this.setState({
                result: res.data.return,
                data: res.data.data
            });
        });
    }

    change(e) {
        console.log(e.target);
        let target = e.target;
        this.setState(state => {
            const formData = state.formData;
            formData[target.name] = target.value;
            return {formData : formData};
        });

        if (e.target.name === "templateId") {
            this.state.data.mailTemplate.map(template => {
               if (target.value == template.id) {
                   this.setState(state => {
                       const formData = state.formData;
                       formData.mailTo = template.mailTo;
                       formData.mailCopy = template.mailCopyTo;
                       formData.mailObject = template.mailSubject;
                       formData.mailBody = template.mailBody;
                       return {formData : formData};
                   });
               }
            });
        }
    }

    onFilesChange = (event, values) => {
        this.setState(state => {
            const formData = state.formData;
            formData.mailFiles = values;
            return {formData : formData};
        });
    }

    async submit(e) {
        e.preventDefault();
        await axios.post(AuthService.getUrl('/saveCroisiereProcess'), this.state.formData, AuthService.getAuthHeader()).then(res => {
            if (res.errorMessage) {
                this.props.closeDialog(e, null, res.data.errorMessage);
            } else {
                this.props.closeDialog(e, res.data.validMessage, null);
            }
        });
    }

    render() {
        if (this.state.result === null) {
            return (
                <img src={loader} alt="loading" style={{"display": "block", "margin": "auto"}}/>
            );
        } else {
            return (
                <div id="processDialog">
                    <div className="dialogTitle">Traitement de la reservation</div>
                    <form id="processDialogForm" onSubmit={e => this.submit(e)}>
                        <div className="line">
                            <div className="label">Statut</div>
                            <select className="value" name="croisiereStatutId"
                                    value={this.state.formData.croisiereStatutId}
                                    onChange={e => this.change(e)}
                                    style={{width: "250px", marginRight: "466px"}}>
                                <option value=""></option>
                                <option value="1">Ne pas changer</option>
                                <option value="4">Confirmer</option>
                                <option value="2">Reporté</option>
                                <option value="3">En attente validation client</option>
                                <option value="6">Annuler</option>
                                <option value="8">Liste d'attente</option>
                            </select>
                        </div>

                        <div className="line">
                            <div className="label">Notification</div>
                            <select className="value" name="templateId"
                                    value={this.state.formData.templateId}
                                    onChange={e => this.change(e)}
                                    style={{width: "250px", marginRight: "466px"}}>
                                <option data-duree="null" value="null"></option>
                                <option value="0">AUCUNE</option>
                                {this.state.data.mailTemplate.map(template => (
                                    <option key={template.id} value={template.id}>{template.mailSubject}</option>
                                ))}
                            </select>
                        </div>
                        {!!this.state.formData.mailObject &&
                        <React.Fragment>
                            <div className="line">
                                <div className="label">Destinataire</div>
                                <input type="text" className="value"
                                       name="mailTo" value={this.state.formData.mailTo}
                                       onChange={this.change}/>
                            </div>
                            <div className="line">
                                <div className="label">Copie</div>
                                <input type="text" className="value"
                                       name="mailCopy" value={this.state.formData.mailCopy}
                                       onChange={this.change}/>
                            </div>
                            <div className="line">
                                <div className="label">Objet</div>
                                <input type="text" className="value"
                                       name="mailObject" value={this.state.formData.mailObject}
                                       onChange={this.change}/>
                            </div>
                            <div className="line">
                                <div className="label">Corps</div>
                                <div className="value">
                                    <div id="toolbar-container"></div>
                                    <div style={{backgroundColor: "#FFFFFF"}}>
                                        <CKEditor
                                            editor={Editor}
                                            data={this.state.formData.mailBody}
                                            onReady={editor => {
                                                // Add the toolbar to the container
                                                const toolbarContainer = document.querySelector('#toolbar-container');
                                                toolbarContainer.appendChild(editor.ui.view.toolbar.element);

                                                window.editor = editor;
                                                // You can store the "editor" and use when it is needed.
                                                console.log('Editor is ready to use!', editor);
                                            }}
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                this.setState(state => {
                                                    const formData = state.formData;
                                                    formData.mailBody = data;
                                                    return {formData: formData};
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="line">
                                <div className="label"></div>
                                <Autocomplete
                                    multiple
                                    id="tags-standard"
                                    options={this.state.data.mailFiles}
                                    getOptionLabel={(option) => option.displayName}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Piéces jointes"
                                            placeholder=""
                                        />
                                    )}
                                    onChange={this.filesChange}
                                    style={{width: 700}}
                                />
                            </div>
                        </React.Fragment>
                        }
                        <div className="line" style={{justifyContent: "space-around"}}>
                            <button type="submit" className="validButton"
                                    disabled={!this.state.formData.croisiereStatutId && !this.state.formData.templateId}>Valider
                            </button>
                        </div>
                    </form>
                </div>
            );
        }
    }
}

export default ProcessDialog;
